import { type InputHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/cn';
interface InputProps extends InputHTMLAttributes<HTMLInputElement> {}

/** @deprecated src/apps/app/src/components/Input/Input.tsx に移行してください */
const Input = forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  ...props
}, ref) => {
  return <input type={type} className={cn('flex h-9 w-full rounded-md border border-neutral-muted-border bg-neutral-fill px-3 py-1 text-sm shadow-xs transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50', className)} ref={ref} {...props} />;
});
Input.displayName = 'Input';
export { Input };